import { useState } from "react";
import api from "../utils/api";

export default function BrokerConnectTradier({ userId }) {
    const [accessToken, setAccessToken] = useState("");
    const [accountId, setAccountId] = useState("");
    const [mode, setMode] = useState("sandbox"); // "sandbox" (paper) or "live"
    const [msg, setMsg] = useState("");

    const save = async () => {
        setMsg("");
        try {
            await api.post("/api/brokers/tradier/save-token", {
                user_id: userId,
                access_token: accessToken.trim(),
                account_id: accountId.trim(),
                mode, // "sandbox" | "live"
            });
            setMsg("Saved.");
        } catch (e) {
            setMsg("Error saving Tradier credentials.");
        }
    };

    const test = async () => {
        setMsg("");
        try {
            const { data } = await api.get("/api/brokers/balances", { params: { user_id: userId } });
            const t = data?.tradier;
            setMsg(
                t
                    ? `OK � Buying Power: ${t.buying_power ?? t.option_buying_power ?? "n/a"}`
                    : "Not connected."
            );
        } catch {
            setMsg("Test failed.");
        }
    };

    return (
        <div className="p-4 bg-zinc-900 rounded-2xl space-y-3">
            <h3 className="text-lg font-semibold">Connect Tradier</h3>

            <input
                className="w-full bg-zinc-800 rounded px-3 py-2"
                placeholder="Access Token"
                value={accessToken}
                onChange={(e) => setAccessToken(e.target.value)}
            />
            <input
                className="w-full bg-zinc-800 rounded px-3 py-2"
                placeholder="Account ID"
                value={accountId}
                onChange={(e) => setAccountId(e.target.value)}
            />

            <select
                className="w-full bg-zinc-800 rounded px-3 py-2"
                value={mode}
                onChange={(e) => setMode(e.target.value)}
            >
                <option value="sandbox">Paper (Sandbox)</option>
                <option value="live">Live</option>
            </select>

            <div className="flex gap-2">
                <button onClick={save} className="bg-blue-600 rounded px-4 py-2">Save</button>
                <button onClick={test} className="bg-zinc-700 rounded px-4 py-2">Test</button>
            </div>

            {msg && <div className="text-sm text-zinc-300">{msg}</div>}
            <p className="text-xs text-zinc-400">
                Tip: Start with a <b>Sandbox</b> (paper) token from Tradier. Switch to Live later.
            </p>
        </div>
    );
}
